import { createSlice } from '@reduxjs/toolkit'
import api, { createWrappedAsyncThunk } from 'src/api'

const SLICE_NAME = 'buyer/inventory'

export const initialState = {
  locations: [],
  location: {},
  isLoading: false,
  error: null,
}

// Async thunks

export const fetchLocations = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchLocations`,
  purchasingEnvironment =>
    api.get(`/buyer/environments/${purchasingEnvironment}/locations/`)
)

export const fetchLocation = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchLocation`,
  args =>
    api.get(
      `/buyer/environments/${args.purchasingEnvironment}/locations/${args.id}/`
    )
)

export const createLocation = createWrappedAsyncThunk(
  `${SLICE_NAME}/createLocation`,
  args =>
    api.post(`/buyer/environments/${args.environmentId}/locations/`, {
      body: args.body,
    })
)

export const updateLocation = createWrappedAsyncThunk(
  `${SLICE_NAME}/updateLocation`,
  args =>
    api.put(
      `/buyer/environments/${args.environmentId}/locations/${args.locationId}/`,
      { body: args.body }
    )
)

export const createItem = createWrappedAsyncThunk(
  `${SLICE_NAME}/createItem`,
  args =>
    api.post(
      `/buyer/environments/${args.environmentId}/locations/${args.locationId}/item/`,
      { body: args.body }
    )
)

export const updateStock = createWrappedAsyncThunk(
  `${SLICE_NAME}/updateStock`,
  args =>
    api.put(
      `/buyer/environments/${args.environmentId}/locations/${args.locationId}/item/${args.itemId}/stock/${args.recordDate}/`,
      { body: args.body }
    )
)

// Slice

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: {
    // For fetchLocations
    [fetchLocations.pending]: state => {
      state.isLoading = true
      state.error = null
    },
    [fetchLocations.fulfilled]: (state, { payload }) => {
      state.locations = payload
      state.isLoading = false
    },
    [fetchLocations.rejected]: (state, { error }) => {
      state.isLoading = false
      state.error = error.message
    },

    // For fetchLocations
    [fetchLocation.pending]: state => {
      state.isLoading = true
      state.error = null
    },
    [fetchLocation.fulfilled]: (state, { payload }) => {
      state.location = payload
      state.isLoading = false
    },
    [fetchLocation.rejected]: (state, { error }) => {
      state.isLoading = false
      state.error = error.message
    },

    // For createLocation
    [createLocation.pending]: state => {
      state.isLoading = true
      state.error = null
    },
    [createLocation.fulfilled]: (state, { payload }) => {
      state.locations.push(payload)
      state.isLoading = false
    },
    [createLocation.rejected]: (state, { error }) => {
      state.isLoading = false
      state.error = error.message
    },

    // For updateLocation
    [updateLocation.pending]: state => {
      state.isLoading = true
      state.error = null
    },
    [updateLocation.fulfilled]: (state, { payload }) => {
      const index = state.locations.findIndex(loc => loc.name === payload.name)
      if (index !== -1) {
        state.locations[index] = payload
      }
      state.isLoading = false
    },
    [updateLocation.rejected]: (state, { error }) => {
      state.isLoading = false
      state.error = error.message
    },

    // For createItem
    [createItem.pending]: state => {
      state.isLoading = true
      state.error = null
    },
    [createItem.fulfilled]: (state, { payload, meta }) => {
      const locIndex = state.locations.findIndex(
        loc => loc.name === meta.arg.locationName
      )
      if (locIndex !== -1) {
        state.locations[locIndex].items.push(payload)
      }
      state.isLoading = false
    },
    [createItem.rejected]: (state, { error }) => {
      state.isLoading = false
      state.error = error.message
    },

    // For updateStock
    [updateStock.pending]: state => {
      state.isLoading = true
      state.error = null
    },
    [updateStock.fulfilled]: (state, { payload, meta, dispatch }) => {
      const locIndex = state.locations.findIndex(
        loc => loc.name === meta.arg.locationName
      )
      if (locIndex !== -1) {
        const itemIndex = state.locations[locIndex].items.findIndex(
          item => item.name === meta.arg.itemName
        )
        if (itemIndex !== -1) {
          dispatch(
            fetchLocation({
              purchasingEnvironment: meta.arg.environmentId,
              id: meta.arg.locationId,
            })
          )
        }
      }
      state.isLoading = false
    },
    [updateStock.rejected]: (state, { error }) => {
      state.isLoading = false
      state.error = error.message
    },
  },
})

export default slice.reducer
